import React, { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';

function Header() {
    const [mobileNavOpen, setMobileNavOpen] = useState(false);

    const trigger = useRef(null);
    const mobileNav = useRef(null);

    // close the mobile menu on click outside
    useEffect(() => {
        const clickHandler = ({ target }) => {
            if (!mobileNav.current || !trigger.current) return;
            if (!mobileNavOpen) return;
            if (mobileNav.current.contains(target) || trigger.current.contains(target)) return;
            setMobileNavOpen(false);
        };
        document.addEventListener('click', clickHandler);
        return () => document.removeEventListener('click', clickHandler);
    }, [mobileNavOpen]);

    // close the mobile menu if the esc key is pressed
    useEffect(() => {
        const keyHandler = ({ keyCode }) => {
            if (!mobileNavOpen || keyCode !== 27) return;
            setMobileNavOpen(false);
        };
        document.addEventListener('keydown', keyHandler);
        return () => document.removeEventListener('keydown', keyHandler);
    }, [mobileNavOpen]);

    return (
        <header className="fixed inset-x-0 top-0 z-30">
            <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8">
                <div className="mt-3 flex items-center justify-between rounded-full bg-black bg-opacity-10 border border-gray-700 backdrop-filter backdrop-blur-md px-3 sm:px-5 py-2 shadow-lg">
                    {/* Site branding */}
                    <div className="flex items-center flex-shrink-0 mr-2 sm:mr-4">
                        <Link to="/" className="block" aria-label="AGM Technologies">
                            <img
                                className="object-contain w-40 h-10 sm:w-48 sm:h-12"
                                src={require('../images/Logo/AGMTechnologies.png').default}
                                alt="AGM Technologies logo"
                            />
                        </Link>
                    </div>

                    {/* Desktop navigation */}
                    <nav className="hidden md:flex md:flex-grow items-center justify-end">
                        <ul className="flex items-center space-x-4 lg:space-x-6 text-xs sm:text-sm font-medium tracking-wide">
                            <li>
                                <Link
                                    to="/telematics"
                                    className="uppercase text-gray-100 px-3 py-1.5 rounded-full hover:text-white hover:bg-white hover:bg-opacity-5 transition duration-150 ease-in-out"
                                >
                                    Telematics
                                </Link>
                            </li>
                            <li>
                                <Link
                                    to="/about"
                                    className="uppercase text-gray-100 px-3 py-1.5 rounded-full hover:text-white hover:bg-white hover:bg-opacity-5 transition duration-150 ease-in-out"
                                >
                                    About
                                </Link>
                            </li>
                        </ul>
                    </nav>

                    {/* Mobile menu button */}
                    <div className="md:hidden flex items-center">
                        <button
                            ref={trigger}
                            className="inline-flex items-center justify-center rounded-full p-2 hover:bg-white hover:bg-opacity-5 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-40 transition"
                            aria-controls="mobile-nav"
                            aria-expanded={mobileNavOpen}
                            onClick={() => setMobileNavOpen(!mobileNavOpen)}
                        >
                            <span className="sr-only">Menu</span>
                            <svg
                                className="w-6 h-6 fill-current text-white"
                                viewBox="0 0 24 24"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <rect y="4" width="24" height="2" rx="1" />
                                <rect y="11" width="24" height="2" rx="1" />
                                <rect y="18" width="24" height="2" rx="1" />
                            </svg>
                        </button>
                    </div>
                </div>

                {/* Mobile navigation */}
                <nav
                    id="mobile-nav"
                    ref={mobileNav}
                    className="md:hidden absolute left-0 right-0 top-16 px-4 sm:px-6 z-20 overflow-hidden transition-all duration-300 ease-in-out"
                    style={
                        mobileNavOpen
                            ? {
                                maxHeight: mobileNav.current
                                    ? mobileNav.current.scrollHeight
                                    : 300,
                                opacity: 1,
                            }
                            : { maxHeight: 0, opacity: 0 }
                    }
                >
                    <ul className="rounded-2xl bg-black bg-opacity-90 border border-gray-700 shadow-xl py-3">
                        <li>
                            <Link
                                to="/telematics"
                                className="block font-medium text-base text-gray-100 hover:text-white hover:bg-white hover:bg-opacity-5 px-4 py-2 rounded-xl transition"
                                onClick={() => setMobileNavOpen(false)}
                            >
                                Telematics
                            </Link>
                        </li>
                        <li>
                            <Link
                                to="/about"
                                className="block font-medium text-base text-gray-100 hover:text-white hover:bg-white hover:bg-opacity-5 px-4 py-2 rounded-xl transition"
                                onClick={() => setMobileNavOpen(false)}
                            >
                                About
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </header>
    );
}

export default Header;
